export default "__VITE_ASSET__7v6g5Ov2__"